<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_form_fields_styles" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<sp-form-input-settings [widget]="widget" [isCartForm]="true" [inputSettingsForm]="itemForm"></sp-form-input-settings>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
